import { useInstancesByQuery } from 'hive-react-utils';
export function useUsers() {
    return useInstancesByQuery('ontariohealth', 'activeUsers', 'user', {});
}
